function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlantTransect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 19.84375 19.843751",
    id: "svg15374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-277.15624)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.20578705,
      strokeOpacity: 1
    },
    id: "rect4518-85-9-8-1",
    width: 19.84375,
    height: 19.84375,
    x: 0,
    y: 277.15625
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#59a14f",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.17834876,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-5-38-2",
    width: 17.197918,
    height: 17.197918,
    x: 1.3229218,
    y: 278.47916
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    id: "g9934",
    transform: "matrix(0.99828413,0,0,1.0315036,-242.71333,379.54969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9502",
    d: "m 247.66367,-83.68748 c 0,0 2.32184,-4.187592 6.07175,-6.270861 2.40736,-1.435141 4.89468,-5.719436 5.29166,-6.614583 l 0.19515,0.107057 c 0,0 -2.72863,6.240419 -4.95765,8.095026 -2.22902,1.854607 -3.63599,5.649056 -3.63599,5.649056 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.26458439px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9549",
    transform: "matrix(0.26458333,0,0,0.26458333,0,-486.83334)",
    d: "m 929.60547,1500.7168 c -0.96587,6.9882 2.41442,14.186 4.91601,18.4121 1.51957,-1.8403 3.38396,-3.9736 5.49414,-6.1816 -4.31369,-8.8433 -10.41015,-12.2305 -10.41015,-12.2305 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.99999994px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9549-9",
    transform: "matrix(0.26458333,0,0,0.26458333,0,-486.83334)",
    d: "m 956.14453,1515.3633 c -1.27279,2.673 -2.04506,5.1085 -2.51758,6.8945 4.43398,0.372 11.17128,0.2333 16.23633,-3.0234 0,0 -4.99138,-3.644 -13.71875,-3.8711 z",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.89999992px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9549-4",
    transform: "matrix(0.26458333,0,0,0.26458333,0,-486.83334)",
    d: "m 942.04688,1492.5957 c -1.43896,5.8411 0.97494,12.2517 2.6582,15.7695 1.58558,-1.4454 3.256,-2.8504 4.99414,-4.1757 -2.67529,-8.0997 -7.65234,-11.5938 -7.65234,-11.5938 z",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.80999994px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9549-4-1",
    transform: "matrix(0.26458333,0,0,0.26458333,0,-486.83334)",
    d: "m 952.93555,1488.6309 c -1.52247,4.4685 -0.16367,9.6291 0.93359,12.6386 0.70431,-0.4426 1.4133,-0.8709 2.13086,-1.2695 0.74412,-0.4436 1.50715,-0.9799 2.27539,-1.5547 -1.60064,-6.6696 -5.33984,-9.8144 -5.33984,-9.8144 z",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.65609992px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9549-4-1-8",
    transform: "matrix(0.26458333,0,0,0.26458333,0,-486.83334)",
    d: "m 960.83398,1485.1191 c -0.80045,3.5169 0.52584,7.3465 1.63477,9.7266 1.06055,-1.0168 2.1112,-2.0934 3.14258,-3.2109 -1.88886,-4.566 -4.77735,-6.5157 -4.77735,-6.5157 z",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.53144091px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9549-4-1-8-5",
    transform: "matrix(0.26458333,0,0,0.26458333,0,-486.83334)",
    d: "m 966.57812,1480.6367 c -0.50258,2.928 0.7843,6.0108 1.79297,7.8789 0.8087,-0.9558 1.58204,-1.9087 2.32813,-2.8515 -1.72504,-3.5759 -4.1211,-5.0274 -4.1211,-5.0274 z",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.43046716px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9549-4-1-8-5-7",
    transform: "matrix(0.26458333,0,0,0.26458333,0,-486.83334)",
    d: "m 971.09375,1476.3438 c -0.19199,2.3773 1.04824,4.7549 1.99414,6.1933 0.62205,-0.8434 1.18938,-1.643 1.7168,-2.4023 -1.65401,-2.7875 -3.71094,-3.791 -3.71094,-3.791 z",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.34867838px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9549-9-6",
    transform: "matrix(0.26458333,0,0,0.26458333,0,-486.83334)",
    d: "m 962.16992,1506.7871 c -1.58836,1.5267 -2.92601,3.2212 -4.03125,4.959 3.4108,0.8791 9.43854,1.8814 14.31836,-0.377 0,0 -3.50144,-3.3805 -10.28711,-4.582 z",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.72899991px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9549-9-6-3",
    transform: "matrix(0.26458333,0,0,0.26458333,0,-486.83334)",
    d: "m 967.91016,1500.1758 c -1.04028,1.5059 -2.08681,2.8675 -3.12305,4.0234 2.69951,0.7131 7.8016,1.6279 11.88672,-0.2871 0,0 -2.99338,-2.8595 -8.76367,-3.7363 z",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.59048992px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9549-9-6-3-6",
    transform: "matrix(0.26458333,0,0,0.26458333,0,-486.83334)",
    d: "m 971.89844,1493.7363 c -0.66206,1.1691 -1.33939,2.3138 -2.0293,3.4278 2.25626,0.4648 6.2689,0.9344 9.41016,-0.7188 0,0 -2.58343,-2.2464 -7.38086,-2.709 z",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.47829688px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9549-9-6-3-6-2",
    transform: "matrix(0.26458333,0,0,0.26458333,0,-486.83334)",
    d: "m 975.51758,1486.9043 c -0.47449,0.9501 -0.94555,1.8866 -1.45899,2.8672 1.85729,0.2753 5.07338,0.4631 7.51368,-0.9883 0,0 -2.17336,-1.6998 -6.05469,-1.8789 z",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.38742048px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9549-9-6-3-6-2-1",
    transform: "matrix(0.26458333,0,0,0.26458333,0,-486.83334)",
    d: "m 978.76172,1480.0957 c -0.34907,0.7698 -0.69739,1.5371 -1.11328,2.4238 1.53442,0.09 4.05674,0 5.88086,-1.291 0,0 -1.76853,-1.1703 -4.76758,-1.1328 z",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.31381056px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlantTransect);
export default __webpack_public_path__ + "static/media/icon-plant-transect.ca61516239134df8d3dba8fdbd18d5c8.svg";
export { ForwardRef as ReactComponent };